<template>
  <div class="articleInfo">
    <div class="line"></div>
    <div class="articleDesc width1200">
      <span class="article-back" @click="goBack">
        <i></i> 返回
      </span>

      <h1 class="title">{{ title }}</h1>
      <!-- 2019-07-13   来源：大雅乐盟 -->
      <p class="source">{{ timeList }}</p>

      <div class="article-content">
        <video
          v-if="videoSrc"
          class="video"
          :src="videoSrc"
          controls
        ></video>
        <p v-if="desc">{{ desc }}</p>
        <div class="content" v-if="content" v-html="content"></div>

        <!-- 怎么帮助孩子学好音乐！<br>
                今天我们从 四个方面<br>
                来谈谈学音乐的那些事<br>
                1.孩子该怎样学音乐？<br>
                我们首先要明确，学音乐的主体是孩子，孩子在学音乐的时候要明白哪些道理？<br>
                1.每天半个小时，坚持十年，比只练三年每天3个小时强。有句老话叫做：贵在坚持。如果每天20—30分钟，坚持10—15年，水平也能达到不错的程度了。<br>
                2.你是在学音乐，吃苦是必须的。想想能流畅、骄傲地演奏出一首首曲子，想想在练琴过程中养成的好习惯和好品质，想想以后的道路有音乐相伴，这其中的付出便很值了不是吗？<br>
                2.家长该怎样引导？<br>
                首先，制定时间表，表上内容包括一周内每日计划练习时段、每日实际练习时段、完成情况等条目。<br>
                制定好以后便要严格执行了，弹琴的时候避免喝水、上厕所、休息一会儿等小动作，如果违反了家长可以考虑制定一些小小的惩罚措施，比如加时5分钟。这样做为的是培养孩子的纪律性，有助孩子集中精力练琴。<br>
                再者，监督指导。小朋友之所以不能专心，一方面可能是对作业要求不明确，课上内容不能完全理解，这时，家长可以引导孩子练习，帮助孩子理解老师的教学要求，注意乐句、节奏、指法、双手协调等方面，使他们没有分散注意力的余地。<br>
                3.老师是怎么教孩子的？<br>
                1.帮孩子打下扎实的基础。无论是学习何种乐器，基本功是重中之重，在初学的阶段，每个负责的老师都会引导孩子了解和掌握基本功与基础知识。<br>
                2.做好示范，激发学生的学习兴趣。孩子普遍具有动作和听觉模仿能力强、理解能力弱的特点，尤其对于低年龄和初学琴的孩子，老师会以自己的方法给孩子做好示范，激发孩子的学习欲望。<br>
                4.大师是怎么练成的？<br>
                一开始就要投入感情。鲍里斯·贝尔曼曾这么说：<br>
        “很多人在学琴的时候会有一个错误的观点：先学技巧，而后再慢慢练习感情的投入。我认为这个练习顺序是错误的。对于音乐作品的理解，特别是对于作品中情感部分的理解，会直接影响我们在弹琴时对于技巧的应用。比如在抒情部分的段落，需要轻巧的、温柔的弹奏，如果没有对于作品情感方面的正确理解，就会影响到弹奏者在触键、和声和音色等方面的控制。同样，对于比较戏剧性段落的弹奏，需要比较强烈的感情投入，感情方面的投入仅仅通过机械的技巧是远远达不到。”-->
      </div>
    </div>

    <!-- <InformationSection/> -->
  </div>
</template>

<style lang="less" scoped>
.line {
  height: 5px;
  background: #f9f9f9;
}
.articleDesc {
  position: relative;
  padding-top: 50px;
  padding-bottom: 60px;

  .article-back {
    position: absolute;
    top: 48px;
    left: 0;
    width: 109px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
    border-radius: 8px;
    display: inline-block;
    color: #777777;
    font-weight: 18px;
    letter-spacing: 5px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;

    i {
      width: 9px;
      height: 9px;
      border-left: 1px solid #9b9b9b;
      border-bottom: 1px solid #9b9b9b;
      transform: rotate(45deg);
      display: inline-block;
    }

    &:hover {
      background: #19928a;
      color: #fff;
      i {
        border-left-color: #fff;
        border-bottom-color: #fff;
      }
    }
  }

  .title {
    color: #4a4a4a;
    font-size: 26px;
    line-height: 35px;
    text-align: center;
    font-weight: bold;
  }
  .source {
    padding-top: 15px;
    padding-bottom: 25px;
    color: #9b9b9b;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
  }

  .article-content {
    width: 1168px;
    margin: 0 auto;
    font-size: 16px;
    color: #4a4a4a;
    line-height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .video {
      width: 810px;
      height: 456px;
    }
    p {
      width: 810px;
      margin-top: 20px;
    }
  }
}
</style>

<script>
// import InformationSection from '@/components/information'
export default {
  name: "articleInfo",
  data() {
    return {
      infos: [
        {
          id: 1,
          title: "唐老师专访-介绍",
          desc: "",
          src:
            "https://oss.dayaedu.com/website/daya-teatang.mp4",
          timeList: "来源：大雅乐盟"
        },
        {
          id: 2,
          title: "大雅管乐团介绍",
          desc: "",
          src:
            "https://oss.dayaedu.com/website/dayaedu-detail.mp4",
          timeList: "来源：大雅乐盟"
        },
        // {
        //   id: 3,
        //   title: "乐团-介绍",
        //   desc: "",
        //   src:
        //     "https://oss.dayaedu.com/website/dayaedu-detail.mp4",
        //   timeList: "来源：大雅乐盟"
        // }
        {
          id: 4,
          title: "《新时代学校美育工作意见》发布，音乐艺术将纳入中考改革",
          desc: '',
          content: `
          <img src="${require('@/assets/post4/image1.jpeg')}"/>
          <p>2020年10月15日，中共中央办公厅、国务院办公厅印发了《关于全面加强和改进新时代学校美育工作的意见》，并发出通知，要求各地区各部门结合实际认真贯彻落实。</p>
          <p>10月16日，教育部体育卫生与艺术教育司司长王登峰介绍《关于全面加强和改进》、《新时代学校体育工作的意见》《关于全面加强和改进新时代学校美育工作》</p>
          <img src="${require('@/assets/post4/image2.png')}"/>
          到2022年，学校美育取得突破性进展，美育课程全面开齐开足，教育教学改革成效显著，资源配置不断优化，评价体系逐步健全，管理机制更加完善，育人成效显著增强，学生审美和人文素养明显提升。到2035年，基本形成全覆盖、多样化、高质量的具有中国特色的现代化学校美育体系。
          <img width="400" src="${require('@/assets/post4/image3.png')}"/>
          <h4 class="title">不断完善课程和教材体系</h4>
          <p>1.树立学科融合理念。加强美育与德育、智育、体育、劳动教育相融合，充分挖掘和运用各学科蕴含的体现中华美育精神与民族审美特质的心灵美、礼乐美、语言美、行为美、科学美、秩序美、健康美、勤劳美、艺术美等丰富美育资源。有机整合相关学科的美育内容，推进课程教学、社会实践和校园文化建设深度融合，大力开展以美育为主题的跨学科教育教学和课外校外实践活动。</p>
          <p>2.完善课程设置。学校美育课程以艺术课程为主体，主要包括音乐、美术、书法、舞蹈、戏剧、戏曲、影视等课程。学前教育阶段开展适合幼儿身心特点的艺术游戏活动。义务教育阶段丰富艺术课程内容，在开好音乐、美术、书法课程的基础上，逐步开设舞蹈、戏剧、影视等艺术课程。高中阶段开设多样化艺术课程，增加艺术课程的可选择性。职业教育将艺术课程与专业课程有机结合，强化实践，开设体现职业教育特点的拓展性艺术课程。高等教育阶段开设以审美和人文素养培养为核心、以创新能力培育为重点、以中华优秀传统文化传承发展和艺术经典教育为主要内容的公共艺术课程。</p>
          <p>3.科学定位课程目标。构建大中小幼相衔接的美育课程体系，明确各级各类学校美育课程目标。学前教育阶段培养幼儿拥有美好、善良心灵和懂得珍惜美好事物。义务教育阶段注重激发学生艺术兴趣和创新意识，培养学生健康向上的审美趣味、审美格调，帮助学生掌握1至2项艺术特长。高中阶段丰富审美体验，开阔人文视野，引导学生树立正确的审美观、文化观。职业教育强化艺术实践，培养具有审美修养的高素质技术技能人才，引导学生完善人格修养，增强文化创新意识。高等教育阶段强化学生文化主体意识，培养具有崇高审美追求、高尚人格修养的高素质人才。</p>
          <p>4.加强教材体系建设。编写教材要坚持马克思主义指导地位，扎根中国、融通中外，体现国家和民族基本价值观，格调高雅，凸显中华美育精神，充分体现思想性、民族性、创新性、实践性。根据学生年龄特点和身心成长规律，围绕课程目标，精选教学素材，丰富教学资源。加强大中小学美育教材一体化建设，注重教材纵向衔接，实现主线贯穿、循序渐进。中小学美育教材按规定审定后使用。高校落实美育教材建设主体责任，做好教材研究、编写、使用等工作，探索形成以美学和艺术史论类、艺术鉴赏类、艺术实践类为主体的高校公共艺术课程教材体系。</p>
          <h4 class="title">全面深化教学改革</h4>
          <p>1.开齐开足上好美育课。严格落实学校美育课程开设刚性要求，不断拓宽课程领域，逐步增加课时，丰富课程内容。义务教育阶段和高中阶段学校严格按照国家课程方案和课程标准开齐开足上好美育课。高等教育阶段将公共艺术课程与艺术实践纳入学校人才培养方案，实行学分制管理，学生修满公共艺术课程2个学分方能毕业。鼓励高校和科研院所将美学、艺术学课程纳入研究生教育公共课程体系。</p>
          <img src="${require('@/assets/post4/image4.png')}"/>
          <p>2.深化教学改革。逐步完善“艺术基础知识基本技能+艺术审美体验+艺术专项特长”的教学模式。在学生掌握必要基础知识和基本技能的基础上，着力提升文化理解、审美感知、艺术表现、创意实践等核心素养，帮助学生形成艺术专项特长。成立全国高校和中小学美育教学指导委员会，培育一批学校美育优秀教学成果和名师工作室，建设一批学校美育实践基地，开发一批美育课程优质数字教育资源。推动高雅艺术进校园，持续建设中华优秀传统文化传承学校和基地，创作并推广高校原创文化精品，以大爱之心育莘莘学子，以大美之艺绘传世之作，努力培养心灵美、形象美、语言美、行为美的新时代青少年。</p>
          <p>3.丰富艺术实践活动。面向人人，建立常态化学生全员艺术展演机制，大力推广惠及全体学生的合唱、合奏、集体舞、课本剧、艺术实践工作坊和博物馆、非遗展示传习场所体验学习等实践活动，广泛开展班级、年级、院系、校级等群体性展示交流。有条件的地区可以每年开展大中小学生艺术专项展示，每3年分别组织1次省级大学生和中小学生综合性艺术展演。加强国家级示范性大中小学校学生艺术团建设，遴选优秀学生艺术团参与国家重大演出活动，以弘扬中华优秀传统文化、革命文化、社会主义先进文化为导向，发挥示范引领作用。</p>
          <p>4.推进评价改革。把中小学生学习音乐、美术、书法等艺术类课程以及参与学校组织的艺术实践活动情况纳入学业要求，探索将艺术类科目纳入初、高中学业水平考试范围。全面实施中小学生艺术素质测评，将测评结果纳入初、高中学生综合素质评价。探索将艺术类科目纳入中考改革试点，纳入高中阶段学校考试招生录取计分科目，依据课程标准确定考试内容，利用现代技术手段促进客观公正评价。</p>
          <p>5.加快艺术学科创新发展。专业艺术教育坚持以一流为目标，进一步优化学科专业布局，构建多元化、特色化、高水平的中国特色艺术学科专业体系，加强国家级一流艺术类专业点建设，创新艺术人才培养机制，提高艺术人才培养能力。艺术师范教育以培养高素质专业化创新型教师队伍为根本，坚定办学方向、坚守师范特质、坚持服务需求、强化实践环节，构建协同育人机制，鼓励艺术教师互聘和双向交流。鼓励有条件的地区建设一批高水平艺术学科创新团队和平台，整合美学、艺术学、教育学等学科资源，加强美育基础理论建设，建设一批美育高端智库。</p>
          `,
          src:
            "",
          timeList: "来源：教育部"
        },
        {
          id: 5,
          title: "收好你的考级证书，它可能是你考入名校的垫脚石！",
          desc: "",
          src:
            "",
          content: `
            <p>2020年暑期考级刚刚结束，相信很多琴童都已经拿到了考级证书，记得把你们的证书收好，它们将在你高考时有大用处！</p>
            <img src="${require('@/assets/post5/image1.png')}"/>
            <p>在很多“211”、“985”高校中都设有艺术特长生，在报考高水平艺术团时，很多院校都对等级证书有所要求，有些学校甚至把“报考项目需获得社会考级最高等级证书”作为门槛。拥有高级别考级证书的孩子，等于拥有了高考降分的机会，往往在冲刺阶段占有更加有利的条件。拥有高级别考级证书、或比赛及演出获奖证书，在报考很多高校高水平艺术团等都享受本科第一批次最终模拟投档线下20分以内，有的高校甚至40分以内。</p>
            <p>比如南京大学在2019年的高水平艺术团招生简章中，拥有考级证书就是报考的硬性条件：</p>
            <img src="${require('@/assets/post5/image2.jpeg')}"/>
            <p>北京邮电大学也明确写出，器乐类学生需要业余9级及以上的证书。</p>
            <img src="${require('@/assets/post5/image3.jpeg')}"/>
            <p>除此以外，包括中国政法大学、复旦大学、南开大学、浙江大学、华中科技大学、东南大学、南京航空航天大学、南京理工大学在内的多所高校，都在高水平艺术团的招生简章中，对证书与比赛方面做出了相应的要求。</p>
            <img src="${require('@/assets/post5/image4.jpeg')}"/>
            <img src="${require('@/assets/post5/image5.jpeg')}"/>
            <img src="${require('@/assets/post5/image6.jpeg')}"/>
            <img src="${require('@/assets/post5/image7.jpeg')}"/>
            <img src="${require('@/assets/post5/image8.png')}"/>
            <p>近年，各大高校为储备高水平艺术人才，相继出台了高水平艺术团的招生计划，这一政策无疑让拥有艺术特长的莘莘学子离自己梦寐以求的学府更近了一步。艺术没有止境，坚持下去，说不定哪天它就会变成你考入名校的垫脚石！</p>
          `,
          timeList: "来源：大雅乐盟"
        },
      ],
      title:'',
      desc:'',
      videoSrc:'',
      timeList:'',
      content: '',
    };
  },
  mounted() {
    let id = this.$route.params.id;
    this.infos.forEach(item => {
        if(item.id == id){
            // 赋值
            this.title = item.title;
            this.desc = item.desc;
            this.videoSrc = item.src;
            this.timeList = item.timeList;
            this.content = item.content;
        }
    });
  },
  components: {
    // InformationSection
  },
  methods: {
    goBack() {
     this.$router.push({path:'/suggest/theme'})
    }
  }
};
</script>
<style lang="less" scoped>
.content{
  max-width: 800px;
  /deep/ p {
    text-indent: 2rem;
    text-align: justify;
    margin-bottom: 10px;
  }
  /deep/ img{
    display: block;
    max-width: 100%;
    margin: 30px auto;
    border-radius: 3px;
  }
}
/deep/ h4.title{
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
</style>
